export const ANALYSE_TIPPS = [
  'Mehrere KI-Agenten prüfen deine Stelle nacheinander — vom Job-Analyst bis zum Fact-Checker.',
  'Wir gleichen jede geforderte Anforderung einzeln mit deinem Profil ab. Gründlich statt schnell.',
  'Recruiter überfliegen einen Lebenslauf im Schnitt in nur ~7 Sekunden — wir optimieren genau dafür.',
  'Passende Keywords helfen, automatische Bewerber-Filter (ATS) zu bestehen.',
  'Der Fact-Checker stellt sicher, dass im Anschreiben nichts erfunden wird.',
  'Gute Analyse braucht Kontext: Wir lesen die ganze Anzeige, nicht nur die Überschrift.',
  'Je vollständiger dein Profil, desto präziser der Fit — und desto stärker das Anschreiben.',
  'Unser CV Expert schreibt keine Floskeln — er formuliert konkret, was zu dir und der Stelle passt.',
];
